import { Tooltip } from '@piggybank/global-toolkit';
import castArray from 'lodash/castArray';
import T from 'prop-types';
import React from 'react';
import { renderMarkdown } from './Markdown';
import { Translation, TranslationScope } from './context';

export const DynamicFormTooltip = ({
  formValues = {},
  marginLeft = '10px',
  path,
}) => (
  <TranslationScope path={path}>
    <Translation path="tooltip">
      {tooltip => (
        <div style={{ display: 'inline-block', marginLeft }}>
          <Tooltip
            title={renderMarkdown(
              tooltip,
              { ...formValues },
              {
                noBottomMargin: true,
                translationPath: [...castArray(path), 'tooltip'],
              }
            )}
          />
        </div>
      )}
    </Translation>
  </TranslationScope>
);

DynamicFormTooltip.propTypes = {
  formValues: T.object,
  marginLeft: T.string,
  path: T.oneOfType([T.string, T.arrayOf(T.string)]).isRequired,
};
